<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> Bot Settings
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse2" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="12">
                      <TextBox v-model="mainChannel" placeholder="@channelName">Bot's Main channel</TextBox>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end">
        <div class="form-actions">
          <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsPage',
  data () {
    return {
      mainChannel: ''
    }
  },
  computed: {
  },
  created () {
    this.$loading.show()
    this.axios.get('settings/item')
      .then(response => {
        this.mainChannel = response.data.data.mainChannel
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  methods: {
    onSubmit () {
      this.$loading.show()
      this.axios.put('settings/item', {mainChannel: this.mainChannel})
        .then((res) => {
          this.$loading.hide()
          if (res.data && res.data.status === 200) {
            this.$toastr.success(res.data.message)
          } else {
            this.$toastr.error(res.data.message)
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/SettingsPage.vue